// extracted by css-extract-rspack-plugin
export default {"filterArea":"h2uRzS8mYEGXPm38","actionsRow":"KhGcXL_7dgM_XiiA","actionsGroup":"yNSiOfTUGwVq70Wl","q_table":"JaSK_VWxZNcyZ1Nh","fallbackView":"hPnLjMy1xaArZDZZ"};